import { EpisodeDetails } from "@/components/episodes/EpisodeDetails";
import { EpisodeImageList } from "@/components/episodes/EpisodeImageList";
import { EpisodeMaskList } from "@/components/episodes/EpisodeMaskList";
import { GenerationMetadata } from "@/components/episodes/GenerationMetadata";
import { RejectWholeEpisodeDialog } from "@/components/episodes/RejectWholeEpisodeDialog";
import { ApiErrorSnackbar } from "@/components/ui/Snackbar";
import { useRejectWholeEpisode } from "@/hooks/use-reject-whole-episode";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { useLocation, useParams } from "react-router";

export function EpisodePage() {
  const { state } = useLocation();

  const tabValueFromState =
    state?.tab === "images" ? 1 : state?.tab === "masks" ? 2 : 0;

  const [tabValue, setTabValue] = useState(tabValueFromState);

  return (
    <>
      <Tabs
        value={tabValue}
        onChange={(_, value) => setTabValue(value)}
        sx={{ marginBottom: 2, minHeight: "32px" }}
      >
        <Tab sx={{ minHeight: "32px", py: 0 }} label="Text" />
        <Tab sx={{ minHeight: "32px", py: 0 }} label="Images" />
        <Tab sx={{ minHeight: "32px", py: 0 }} label="Masks" />
        <Tab sx={{ minHeight: "32px", py: 0 }} label="Generation metadata" />
      </Tabs>
      {tabValue === 0 && <TextTabPanel />}
      {tabValue === 1 && <EpisodeImageList />}
      {tabValue === 2 && <EpisodeMaskList />}
      {tabValue === 3 && <GenerationMetadata />}
    </>
  );
}

function TextTabPanel() {
  const { id } = useParams();

  const {
    confirmRejectWholeEpisode,
    setConfirmRejectWholeEpisode,
    handleRejectWholeEpisode,
    isRejectingWholeEpisode,
    canRejectEpisode,
    error: rejectWholeEpisodeError,
  } = useRejectWholeEpisode({
    episodeId: id || "",
    shouldNavigateToNext: false,
  });

  if (!id) {
    return null;
  }

  return (
    <Box sx={{ marginBottom: 2 }}>
      <ApiErrorSnackbar error={rejectWholeEpisodeError} />
      <EpisodeDetails
        id={id}
        onRejectWholeEpisode={
          canRejectEpisode
            ? () => setConfirmRejectWholeEpisode(true)
            : undefined
        }
      />
      <RejectWholeEpisodeDialog
        open={confirmRejectWholeEpisode}
        onClose={() => setConfirmRejectWholeEpisode(false)}
        onConfirm={handleRejectWholeEpisode}
        isLoading={isRejectingWholeEpisode}
      />
    </Box>
  );
}
